import * as React from "react";
import * as ReactDOM from "react-dom";

import { Input } from "./components/Input";

import * as jQuery from "jquery";

jQuery(function() {
    var nodeList = document.getElementsByClassName('ttTimepicker');
    for (var i = 0; i < nodeList.length; ++i) {
        ReactDOM.render(
            <Input key={nodeList[i].id} id={nodeList[i].id} beginuur={nodeList[i].getAttribute('data-value-begin')} einduur={nodeList[i].getAttribute('data-value-einde')}/>,
            nodeList[i]
        );
    };
});


// WEBPACK FOOTER //
// ./apps/site2/components/aStadBetweenTimes/index.tsx